// user（用户）相关
export const RECEIVE_ADMIN_TOKEN = 'RECEIVE_ADMIN_TOKEN'; // token
export const RECEIVE_ADMIN_NAME = 'RECEIVE_ADMIN_NAME'; // 昵称
export const RECEIVE_LADY_ID = 'RECEIVE_LADY_ID';
export const RECEIVE_RULE_READ = 'RECEIVE_RULE_READ';//阅读规则
export const RECEIVE_PASS_WORD = 'RECEIVE_PASS_WORD';//重置密码

// API
export const API_CODE = {
  OK: 0,
  INVALID_TOKEN: 20003,
  SYSTEM_CODE: 11000,//系统维护
};

//订单状态 (0:未配送；1:已配送；2:已完成；)
export const ORDERS_STATE = {
  NO_DELIVERY: "NO_DELIVERY",
  DELIVERED: "DELIVERED",
  FINISHED: "FINISHED",
};

//订单排序（0：时间正序； 1：时间倒叙；2：地址排序）
export const ORDER_SORT_TYPE = {
  DEFAULT:0,
  TIME_NORMAL:2,
  TIME_ABNORMAL:1,
  ADDRESS:3
};

export const REQUEST_PAGE_LIMIT = {
  PAGE: 1,
  LIMIT: 10
};

//客户检索（0：客户名； 1：会员编号；2：手机号; 3：地址）
export const CUSTOM_SORT_SEARCH = {
    USER_NAME: 0,
    MEMBER_NO: 1,
    MOBILE: 2,
    ADDRESS: 3
};

//销售（0：客户； 1：路边；）
export const SALE_CUSTOM_ROAD = {
    SALES: 0,
    SAMPLE: 1,
};

// 商品类型
export const GOOD_TYPE = {
    SELL: 'SELL',
    MATCH: 'MATCH',
};